module.exports = ".sort-container {\n    width: 100%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/sort-header/sort-header.component.css
// module id = ./src/app/common/sort-header/sort-header.component.css
// module chunks = main